module.exports = __webpack_public_path__ + "img/l4.d7001655.png";